<template>
  <div class="card-container">
    <div v-if="showChart" class="chart-info">
      <div class="title" @click="showAlert">
        {{ $t('quote.brief.funds') }}
      </div>
      <p class="captial-summary">
        <template v-for="(item, idx) in inOutFlow">
          <span :key="idx" class="captial-flow-item"
          >{{ item.name }}:&nbsp;<span :class="item.redGreen | redGreen">{{
            item.value
          }}</span
          >&nbsp;&nbsp;</span
          >
        </template>
      </p>
      <div class="captial-chart-wrap">
        <EChart
          class="captial-chart-donut"
          :options="donutChartOptions"
          :width="120"
          :height="100"
        />
        <EChart
          class="captial-chart-bar"
          :options="barChartOptions"
          :width="170"
          :height="125"
        />
      </div>
      <p
        class="today-funds-intro"
        :class="{ 'fit-margin': language === 'en-us' }"
      >
        {{ $t('quote.brief.today-funds-intro') }}
      </p>
    </div>
    <div v-else class="financial-info-empty">
      {{ $t('quote.no-data') }}
    </div>
  </div>
</template>
<script>
import EChart from 'com/EChart'
import Icon from 'com/Icon'
import Modal from 'com/Modal'
import { mapGetters } from 'vuex'
import themeMixin from './theme-mixin'
import FundsCardBarOption from './FundsCardBarOption'
import FundsCardDonutOption from './FundsCardDonutOption'

export default {
  name: 'FundsCard',
  props: {
    chartData: Array,
    isRedUp: Boolean,
    cashFlow: Object
  },
  components: {
    Icon,
    EChart
  },
  mixins: [themeMixin, FundsCardBarOption, FundsCardDonutOption],
  computed: {
    ...mapGetters(['language']),
    showChart() {
      const hasData = this.chartData.length > 0
      return hasData
    },
    upType() {
      return this.isRedUp ? 'redUp' : 'greenUp'
    },
    inOutFlow() {
      // 流入，流出，净额
      const { inflow, outflow, netflow } = this.cashFlow
      const ary = [
        {
          name: this.$t('trade.today-captial.inflow'),
          value: this.formatFlow(inflow),
          redGreen: inflow
        },
        {
          name: this.$t('trade.today-captial.outflow'),
          value: this.formatFlow(Math.abs(outflow)),
          redGreen: +outflow === 0 ? 0 : -1 // 不显示负号，非0固定迭色
        },
        {
          name: this.$t('trade.today-captial.netflow'),
          value: this.formatFlow(netflow),
          redGreen: netflow
        }
      ]
      return ary
    },
    bigSmallFlow() {
      // 大单，小单，中单
      const { bigNetflow, medianNetflow, smallNetflow } = this.cashFlow
      const ary = [
        {
          name: this.$t('trade.today-captial.large'),
          color: this.getColorByNetflow('big', bigNetflow),
          showValue: this.formatFlow(bigNetflow),
          value: bigNetflow
        },
        {
          name: this.$t('trade.today-captial.median'),
          color: this.getColorByNetflow('median', medianNetflow),
          showValue: this.formatFlow(medianNetflow),
          value: medianNetflow
        },
        {
          name: this.$t('trade.today-captial.small'),
          color: this.getColorByNetflow('small', smallNetflow),
          showValue: this.formatFlow(smallNetflow),
          value: smallNetflow
        }
      ]
      return ary
    }
  },
  methods: {
    getColorByNetflow(type, value) {
      if (+value === 0) return
      const inOrOut = value > 0 ? 'Inflow' : 'Outflow'
      return this.flowList[this.upType][type + inOrOut]
    },
    getAlpha(index) {
      const length = this.normalizedData.length
      return (length - index) / length
    },
    formatFlow(value) {
      return this.$options.filters.largeNumber(value, 1)
    },
    showAlert() {
      Modal.open({
        title: this.$t('quote.brief.funds'),
        content: this.$t('quote.brief.funds-intro'),
        cancelButton: false,
        style: { textAlign: 'left' }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.card-container {
  .title {
    color: var(--default-font-color);
    font-size: 12px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      height: 14px;
      width: 14px;
      margin-left: 5px;
      .icon {
        width: 100%;
        height: 100%;
        vertical-align: 4px;
      }
    }
  }
  .chart {
    margin: 0 auto;
  }
  .funds-info {
    position: absolute;
    top: 10px;
    right: 10px;
    color: var(--default-font-color);
    cursor: pointer;
  }
  .financial-info-empty {
    margin-top: 100px;
  }
  .today-funds-intro {
    font-size: 20px;
    transform: scale(0.5);
    transform-origin: 0 0;
    width: 200%;
    margin: 0;
    color: #838d9e;
    margin-top: 10px;
    margin-bottom: -10px;
  }
  .fit-margin {
    margin-bottom: -25px;
  }
}
</style>

<style lang="less">
.card-container {
  .captial {
    &-summary {
      font-size: 12px;
      margin: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    &-flow-item {
      display: inline-block;
    }
    &-chart-wrap {
      display: flex;
      flex-direction: row;
    }
    &-chart-donut {
      width: 120px;
      flex-grow: 0;
      margin-top: 15px;
    }
    &-chart-bar {
      width: 170px;
      margin-left: 10px;
      margin-top: 10px;
      flex-grow: 0;
      flex-shrink: 0;
    }
  }
  .donut-tooltip {
    height: 37px;
    line-height: 37px;
    padding: 0 10px;
    font-size: 12px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
}
</style>
